import {
  memo,
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState,
} from "react";
import { useTranslation } from "react-i18next";
import { isWidgetDisplayed } from "../../../../../esri/widgets/expandUtils";
import useOnboarding from "../../../../../hooks/useOnboarding";
import { ConfigContext } from "../../../../../utils/ConfigContext";
import { InfoIcon, QuestionIcon, ShowMeAroundIcon } from "../../../../Icons";
import Section from "../UI/Section/Section";
import AboutModal from "./AboutModal/AboutModal";

const CLUSTER_SUPPORTED_LANGUAGES = ["en", "fr", "es", "pt"];

const Support = ({ expanded }) => {
  const { config } = useContext(ConfigContext);
  const [showModal, setShowModal] = useState(false);
  const { t } = useTranslation("common");
  const [selected, setSelected] = useState(false);
  const { onBoardingTour } = useOnboarding();

  useEffect(() => {
    if (expanded && !selected) {
      setSelected(false);
    }
  }, [expanded]);

  const handleStartTour = useCallback(() => {
    if (!onBoardingTour) return;
    onBoardingTour.start();
  }, [onBoardingTour]);

  const handleClick = () => {
    setSelected((prev) => !prev);
  };

  const options = useMemo(() => {
    const res = [];

    if (isWidgetDisplayed(config, "Onboarding")) {
      res.push({
        title: t("screen.widget.Support.onboarding.title"),
        icon: <ShowMeAroundIcon width="14px" height="14px" />,
        onClick: handleStartTour,
        description: t("screen.widget.Support.onboarding.information"),
      });
    }

    res.push({
      title: t("screen.widget.Support.about.title"),
      description: t("screen.widget.Support.about.information"),
      icon: <InfoIcon width="14px" height="14px" />,
      onClick: () => {
        setShowModal(true);
      },
    });

    return res;
  }, [config, handleStartTour, t]);

  return (
    <>
      <AboutModal show={showModal} handleClose={() => setShowModal(false)} />
      <Section
        className="onboarding-support"
        selected={selected}
        onClick={handleClick}
        expanded={expanded}
        options={options}
        title={t("screen.widget.Support.name")}
        information={t("screen.widget.Support.information")}
        Icon={QuestionIcon}
      />
    </>
  );
};

export default memo(Support);
